var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Radio from 'antd/lib/radio';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Select from 'antd/lib/select';
import { getOption, getParentNode } from '../utils';
var Panel = Collapse.Panel;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var EditorState = /** @class */ (function (_super) {
    __extends(EditorState, _super);
    function EditorState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            _this.props.onChange('cursor', e);
        };
        return _this;
    }
    EditorState.prototype.render = function () {
        var _this = this;
        var _a = this.props, showClassState = _a.showClassState, locale = _a.locale, isMobile = _a.isMobile, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["showClassState", "locale", "isMobile", "value", "onChange"]);
        var childrenToRender = Object.keys(locale.styleSelect).map(function (key) {
            var item = locale.styleSelect;
            if (isMobile && item[key] === 'hover') {
                return null;
            }
            return (React.createElement(RadioButton, { value: key, key: key, className: "ant-radio-button-auto-width" }, item[key]));
        }).filter(function (c) { return c; });
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 24 }, locale.cursor)),
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 24 },
                    React.createElement(Select, { style: { width: '100%' }, value: value.cursor || 'auto', size: "small", onChange: this.onChange, getPopupContainer: function (node) { return getParentNode(node, 'editor-list'); }, dropdownMatchSelectWidth: false, dropdownClassName: "editor-list-dropdown" }, getOption(locale.cursorSelect, true)))),
            showClassState && [
                React.createElement(Row, { gutter: 8, key: "0" },
                    React.createElement(Col, { span: 24 }, locale.style)),
                React.createElement(Row, { gutter: 8, key: "1" },
                    React.createElement(Col, { span: 24 },
                        React.createElement(RadioGroup, { value: value.classState, size: "small", onChange: function (e) {
                                _this.props.onChange('classState', e.target.value);
                            } }, childrenToRender)))
            ]));
    };
    EditorState.propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func,
        header: PropTypes.string,
        locale: PropTypes.object,
        showClassState: PropTypes.bool,
        isMobile: PropTypes.bool,
    };
    EditorState.defaultProps = {
        value: {},
        onChange: function () {
        },
    };
    return EditorState;
}(Component));
export default EditorState;
EditorState.componentName = 'EditorState';
